// export enum DrugTypes {
// 	Synthetic = 1,
// 	Biotech = 2
// };

export enum Role {
  Administrator = 1,
  ProductManager = 2,
  RegionalManager = 3,
  Trader = 4
}

export enum Lang {
  bg = 1,
  en = 2
}

export enum OfferStatus {
  New = 1,
  Expired = 2,
  Accepted = 3,
  InExecution = 4,
  Finished = 5,
  SentToClient = 6
}

export enum ActiveFilterType {
  All = 1,
  Actives = 2,
  NotActives = 3,
}

export enum TimePeriod {
  Month = 1,
  Quarter = 2,
  Year = 3
}

export enum Units {
  UnitNumber = 1,
  UnitLinearMeter = 2
}

export enum ProductRelationTypes {
  InstallationActivity = 1,
  Fastener = 2,
  Package = 3,
  Labor = 4,
  Kits = 5,
}

export enum FileSystemType {
  Offer = 1,
  BillOfQuantities = 2,
  AxonometricDiagramGas = 3,
  AxonometricDiagramHeat = 4,
  Installation = 5,
  ProductImage = 6,
  BillOfQuantitiesLabor = 7,
}

export enum CategoryType {
  GasInstallation = 1,
  HeatInstallation = 2,
  Devices = 3,
  Packages = 4,
  Services = 5,
  Equipment = 6,
  Materials = 7,
  Radiators = 8,
  Labor = 9,
  Pipes = 10,
  Kits = 11,
  Cauldrons = 12,
  Stoves = 13,
  Flues = 14,
  Boilers = 15,
  TowelRails = 16,
  Convectors = 17
}